export default __webpack_public_path__ + "static/challenge_back-3e419b8e47742e13f08d623df2c17bd8.webp";